import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetBusinessUnitQuery } from '@/services/businessunit.service';
import { formatDateTimeAutoToString } from '@/utils/format';

export default function AddRental() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { data: businessunit } = useGetBusinessUnitQuery(location.state?.id || '', {
    refetchOnMountOrArgChange: true,
  })

  return (
    <div
      x-show="modalOpen"
      x-transition=""
      className="fixed top-0 left-0 z-99999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5"
    >
      <div className="w-full max-w-screen-md rounded-lg bg-white py-5 px-8 dark:bg-boxdark">
        <h3 className="text-lg dark:text-white text-center font-medium mb-5">
          {t('businessunit.information')}
        </h3>
        <div className='flex justify-between mb-5'>
          <div>
            <div className='mb-1 text-black dark:text-white'>
              <b className='me-2'>{t('businessunit.company')}:</b>
              <span>{businessunit?.company.name}</span>
            </div>
            <div className='mb-1 text-black dark:text-white'>
              <b className='me-2'>{t('businessunit.name')}:</b>
              <span>{businessunit?.name}</span>
            </div>
            <div className='mb-1 text-black dark:text-white'>
              <b className='me-2'>{t('businessunit.account')}:</b>
              <span>{businessunit?.account}</span>
            </div>
            <div className='mb-1 text-black dark:text-white'>
              <b className='me-2'>{t('businessunit.take_over')}:</b>
              <span>{businessunit?.take_over ? formatDateTimeAutoToString(businessunit?.take_over, "YYYY-MM-DD") : ''}</span>
            </div>
            <div className='mb-1 text-black dark:text-white'>
              <b className='me-2'>{t('form.description')}:</b>
              <span>{businessunit?.description}</span>
            </div>
            <div className='mb-1 text-black dark:text-white'>
              <b className='me-2'>{t('businessunit.landlord_name')}:</b>
              <span>{businessunit?.landlord_name}</span>
            </div>
          </div>
          <div className='flex flex-col'>
            <div className='mb-1 text-black dark:text-white'>
              <b className='me-2'>{t('businessunit.address')}:</b>
              <span>{businessunit?.address}</span>
            </div>
            <div className='mb-1 text-black dark:text-white'>
              <b className='me-2'>{t('businessunit.condo')}:</b>
              <span>{businessunit?.condo}</span>
            </div>
            <div className='mb-1 text-black dark:text-white'>
              <b className='me-2'>{t('businessunit.unit')}:</b>
              <span>{businessunit?.unit}</span>
            </div>
            <div className='mb-1 text-black dark:text-white'>
              <b className='me-2'>{t('businessunit.door_pin')}:</b>
              <span>{businessunit?.door_pin}</span>
            </div>
            <div className='mb-1 text-black dark:text-white'>
              <b className='me-2'>{t('businessunit.condo_card')}:</b>
              <span>{businessunit?.condo_card}</span>
            </div>
            <div className='mb-1 text-black dark:text-white'>
              <b className='me-2'>{t('businessunit.bank')}:</b>
              <span>{businessunit?.bank}</span>
            </div>
            <div className='mb-1 text-black dark:text-white'>
              <b className='me-2'>{t('businessunit.bank_account')}:</b>
              <span>{businessunit?.bank_account}</span>
            </div>
          </div>
        </div>
        <div className="flex justify-center">
          <div>
            <button
              type="button"
              onClick={() => navigate(location)}
              className="block w-full rounded border border-stroke bg-gray-400 p-1.5 px-3 text-center font-medium text-black transition hover:bg-opacity-90"
            >
              {t('modal.cancel')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
